import { Blob } from "../components/Blob";
import { Eyebrow } from "../components/Eyebrow";
import { GridBg } from "../components/GridBg";
import { WaitlistForm } from "../components/WaitlistForm";
import { copy } from "../content/copy";

export function Hero() {
  const c = copy.hero;
  return (
    <section className="hero" id="top">
      <GridBg />
      <Blob color="orange" position="tl" />
      <Blob color="lime" position="tr" />
      <div className="container hero__inner">
        <div className="hero__eyebrow">
          <Eyebrow>{c.eyebrow}</Eyebrow>
        </div>
        <h1 className="hero__headline">
          {c.headlinePre}
          <span className="serif-italic">{c.headlineEmphasis1}</span>
          {c.headlineMid}
          <span className="serif-italic">{c.headlineEmphasis2}</span>
          {c.headlineSuffix}
          <br />
          <span className="underline-lime">{c.headlineUnderline}</span>
        </h1>
        <p className="hero__sub">{c.sub}</p>
        <div className="hero__form-wrap" id="waitlist">
          <WaitlistForm location="hero" />
        </div>
      </div>
    </section>
  );
}
